import React from 'react';
import classnames from 'classnames';

interface TabProps {
    id: string;
    active: boolean;
    setActiveTab: (_: 'cardType' | 'brand') => void;
}

const Tab = ({ id, active, children, setActiveTab }: React.PropsWithChildren<TabProps>) => {
    const onClick = () => {
        setActiveTab(id as 'cardType' | 'brand');
    };
    return (
        <p
            onClick={onClick}
            className={classnames(
                active ? 'border-b-4 border-bonus-pink text-brand-dark' : 'underline text-brand',
                'cursor-pointer'
            )}
        >
            {children}
        </p>
    );
};

interface TabsProps extends Pick<TabProps, 'setActiveTab'> {
    activeTab: 'cardType' | 'brand';
}

export const Tabs = ({ activeTab, setActiveTab }: TabsProps) => {
    return (
        <div className="flex justify-evenly">
            <Tab id={'cardType'} setActiveTab={setActiveTab} active={activeTab === 'cardType'}>
                Gift Card Type
            </Tab>
            <Tab id={'brand'} setActiveTab={setActiveTab} active={activeTab === 'brand'}>
                Brand
            </Tab>
        </div>
    );
};
